import wineList1 from './assets/img/wineList/1.webp'
import wineList2 from './assets/img/wineList/2.webp'
import wineList3 from './assets/img/wineList/3.webp'
import wineList4 from './assets/img/wineList/4.webp'
import wineList5 from './assets/img/wineList/5.webp'
import wineList6 from './assets/img/wineList/6.webp'
import wineList7 from './assets/img/wineList/7.webp'
import wineList8 from './assets/img/wineList/8.webp'
import wineList9 from './assets/img/wineList/9.webp'
import wineList10 from './assets/img/wineList/10.webp'

export const wineListSlike = [
    {
      src: wineList1,
      title: 'Restaurant Dubrovnik Wine List',
      description: 'Restaurant Dubrovnik wine list- only the best custom selected wines and champagnes',
    },
    {
     src: wineList2,
     title: 'Restaurant Dubrovnik Wine List',
     description: 'Restaurant Dubrovnik wine list- only the best custom selected wines and champagnes',
    },
    {
     src: wineList3,
     title: 'Restaurant Dubrovnik Wine List',
     description: 'Restaurant Dubrovnik wine list- only the best custom selected wines and champagnes',
    },
    {
     src: wineList4,
     title: 'Restaurant Dubrovnik Wine List',
     description: 'Restaurant Dubrovnik wine list- only the best custom selected wines and champagnes',
    },
    {
     src: wineList5,
     title: 'Restaurant Dubrovnik Wine List',
     description: 'Restaurant Dubrovnik wine list- only the best custom selected wines and champagnes',
    },
    {
     src: wineList6,
     title: 'Restaurant Dubrovnik Wine List',
     description: 'Restaurant Dubrovnik wine list- only the best custom selected wines and champagnes',
    },
    {
     src: wineList7,
     title: 'Restaurant Dubrovnik Wine List',
     description: 'Restaurant Dubrovnik wine list- only the best custom selected wines and champagnes',
    },
    {
     src: wineList8,
     title: 'Restaurant Dubrovnik Wine List',
     description: 'Restaurant Dubrovnik wine list- only the best custom selected wines and champagnes',
    },
    {
     src: wineList9,
     title: 'Restaurant Dubrovnik Wine List',
     description: 'Restaurant Dubrovnik wine list- only the best custom selected wines and champagnes',
    },
    {
     src: wineList10,
     title: 'Restaurant Dubrovnik Wine List',
     description: 'Restaurant Dubrovnik wine list- only the best custom selected wines and champagnes',
    },
]

